import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import "@fontsource/cormorant-garamond/300.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/300-italic.css";
import "@fontsource/cormorant-garamond/400-italic.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/jetbrains-mono/400.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { CartDrawer } from "./components/site/CartDrawer";
import { Preloader } from "./components/site/Preloader";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import Story from "./pages/Story";
import Contact from "./pages/Contact";
import Track from "./pages/Track";
import Checkout from "./pages/Checkout";
import OrderConfirmed from "./pages/OrderConfirmed";
import Account from "./pages/Account";
import ComingSoonPage from "./pages/ComingSoonPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -80 } });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
  useEffect(() => {
    if (hash) return;
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Preloader />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:category" element={<Shop />} />
            <Route path="/product/:handle" element={<Product />} />
            <Route path="/our-story" element={<Story />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/track-order" element={<Track />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order/:number" element={<OrderConfirmed />} />
            <Route path="/account" element={<Account />} />
            <Route path="/coming-soon" element={<ComingSoonPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <CartDrawer />
        <Toaster position="bottom-center" />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
